export default {"src":"/_next/static/media/globalCover_64.f1ecc2b2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};